module.exports = __webpack_public_path__ + "img/Logo_Governança_Empreendedora-preta.d9734dcd.png";